import API from '../api.js';

export default () => ({
    // redirectUri with a null value defaults in the backend
    async handleLogin(code: string, type: 'google', redirectUri: string | null) {
        return await API.postJSON(
            '/api/sso/handle-login',
            {
                code,
                type,
                redirectUri,
            },
            false
        )
            .then(response => {
                const json = response.json();

                if (response.status !== 409) {
                    return json;
                }

                return Promise.reject({
                    status: response.status,
                    statusText: response.statusText,
                    json: json,
                });
            })
            .catch(API.error);
    },
});
